// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5b1e83c2","459":"eee3c25c"}[chunkId] + ".chunk.js";
};